import { type InsuranceCorporateIdentity } from "../types";

export function SVLFGLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M256.713 64C150.827 64 64 149.372 64 255.911C64 348.339 129.649 428.067 220.006 445V437.944C128.944 418.189 71.0591 327.172 91.5304 236.156C112.002 145.139 201.652 87.2833 293.42 107.039C385.188 126.794 442.367 217.811 422.601 308.828C408.483 373.033 358.364 423.833 293.42 437.944V445C397.894 425.244 466.368 324.35 446.602 219.928C428.954 129.617 349.187 64 256.713 64ZM256.803 118.007C170.794 118.007 101.705 187.394 101 273.066C101 345.285 150.349 408.299 220.849 425.292V417.504C151.054 396.971 110.87 324.044 131.315 253.241C147.53 197.307 198.994 158.365 256.803 157.657C329.418 158.365 387.932 217.839 387.932 290.766C387.227 349.533 348.452 401.219 292.758 417.504V426C375.947 406.883 428.117 323.336 409.082 239.08C392.867 167.569 329.418 117.299 256.803 118.007ZM140.007 293.43C139.303 227.933 191.401 173.704 256.875 173C306.861 174.409 351.214 206.805 366.702 253.991C387.823 315.966 354.03 382.872 292.076 404V395.549C327.277 380.759 350.51 346.25 350.51 307.515C351.214 268.076 327.277 232.863 290.668 218.777C242.09 199.762 186.473 223.707 167.464 272.302C148.455 320.896 172.392 376.534 220.97 395.549V404C173.096 388.506 140.711 344.137 140.007 293.43ZM226.483 316H203V340C203 352.706 213.674 364 226.483 364H249.966V340C250.678 326.588 240.004 316 226.483 316ZM263.528 364V340C262.824 326.588 273.386 316 286.764 316H310V340C310 353.412 299.438 364 286.764 364H263.528ZM239.472 305.25L256.73 322L273.989 305.25C283.337 296.177 283.337 280.823 273.989 271.75L256.73 255L239.472 271.75C230.843 281.521 230.843 296.177 239.472 305.25ZM253 371H260V452H253V371Z"
        fill="white"
      />
    </svg>
  );
}

export const SVLFG: InsuranceCorporateIdentity = {
  id: "svlfg",
  name: "SVLFG",
  logo: SVLFGLogo,
  backgroundColor: "#68B42E",
  textColor: "#FFFFFF",
  wildcard: "svlfg",
  type: "statutory",
};
